const automaticReports = require('../automaticReports')
const traccarHelper = require('../util/traccar')
const distance = require('@turf/distance')

async function createGPSJumpReport (from, to, userData, traccar, minDistance) {
  let reportData = []

  const devices = userData.devices

  const sliced = automaticReports.sliceArray(devices, 10)
  let deviceCount = 0
  for (const slice of sliced) {
    const allInOne = await traccarHelper.getAllInOne(traccar, from, to, slice, true, false, false, false, deviceCount, devices.length)

    slice.forEach(d => {
      const deviceData = getDeviceData(allInOne, d, userData.user, minDistance || userData.minDistance)
      reportData = reportData.concat(deviceData)
    })

    deviceCount = deviceCount + slice.length
  }

  return reportData
}

function getDeviceData (allInOne, d, user, minDistance) {
  const deviceRoute = allInOne.route.filter(t => t.deviceId === d.id)

  return deviceRoute.map((pA, index) => {
    if (index < deviceRoute.length - 1) {
      const pB = deviceRoute[index + 1]
      const distanceValue = distance.default([pA.longitude, pA.latitude], [pB.longitude, pB.latitude], { units: 'meters' })
      if ((minDistance * 1000) < distanceValue) {
        return {
          device: d.name,
          dateA: pA.fixTime,
          addressA: pA.address,
          dateB: pB.fixTime,
          addressB: pB.address,
          distance: distanceValue
        }
      }
    }
    return undefined
  }).filter(a => a).sort((a, b) => (a.device > b.device) ? 1 : -1)
}

async function exportGPSJumpReportToPDF (userData, reportData) {

}

async function exportGPSJumpReportToExcel (userData, reportData) {

}

exports.createGPSJumpReport = createGPSJumpReport
exports.exportGPSJumpReportToPDF = exportGPSJumpReportToPDF
exports.exportGPSJumpReportToExcel = exportGPSJumpReportToExcel
exports.create = createGPSJumpReport
exports.exportToPDF = exportGPSJumpReportToPDF
exports.exportToExcel = exportGPSJumpReportToExcel
